export const env = {
	apiUrl: import.meta.env.VITE_API_URL,
	frontendUrl: import.meta.env.VITE_FRONTEND_URL,
	sentryDsnKey: import.meta.env.VITE_SENTRY_DSN_KEY,
	cloudFrontUrl: import.meta.env.VITE_CLOUDFRONT_URL,
	getWaitListId: import.meta.env.VITE_GET_WAITLIST_ID,
	getWaitListApi: import.meta.env.VITE_GET_WAITLIST_API,
	googleTrackingId: import.meta.env.VITE_GOOGLE_TRACKING_ID,
	tawkPropertyId: import.meta.env.VITE_TAWK_PROPERTY_ID,
	tawkWidgetId: import.meta.env.VITE_TAWK_WIDGET_ID,
	reCaptchaSiteKey:
		import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY ||
		'6LdXnqUrAAAAAO24h64zWzvJ7wgtKATRQtBK51dT'
}
